import React from "react";

export default function Quotes() {

    const svg = `
<svg width="92px" height="68px" viewBox="0 0 92 68" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g fill="#000000">
            <path d="M21.6782609,41.6335907 C21.6782609,41.6335907 42,41.6335907 42,20.8167954 C42,0 21.6782609,0 21.6782609,0 C21.6782609,0 0,0 0,20.8167954 C0,41.6335907 18.9678261,68 23.0325,68 C27.0971739,68 1.35521739,41.632278 21.678587,41.632278 L21.6782609,41.6335907 Z"/>
            <path d="M71.6782609,41.6335907 C71.6782609,41.6335907 92,41.6335907 92,20.8167954 C92,0 71.6782609,0 71.6782609,0 C71.6782609,0 50,0 50,20.8167954 C50,41.6335907 68.9678261,68 73.0325,68 C77.0971739,68 51.3552174,41.632278 71.678587,41.632278 L71.6782609,41.6335907 Z"/>
        </g>
    </g>
</svg>`;

    return (
        <i className="icon" dangerouslySetInnerHTML={{__html: svg}}/>
    )
}
